import { frenchDate } from "../../../variables/functions";
import { displayNumbers } from "../../../variables/numbersFunctions";
import { dossierDeLigne } from "./groupeReglement";

// Tableau récapitulatif d'un règlement groupé, partagé par l'ordre de dépense,
// la fiche de demande de règlement et la quittance : une ligne par règlement du
// groupe avec les infos de SON dossier (N° sinistre, survenance, police,
// immatriculation, assuré, nature, montant) + total. Quand une ligne ne porte
// pas son propre sinistre (impression depuis le détail sinistre), repli sur le
// sinistre de référence passé en prop.
const TableauDossiersGroupe = ({ decaissement, sinistre, fontSize = "11px", fontFamily }) => {
    // N'afficher que les composantes RÉELLEMENT PAYÉES (montant > 0) : on masque les lignes à 0
    // (ex. frais non payés) pour éviter des lignes « 0 » sur l'ordre de dépense.
    const lignes = (decaissement?.lignes || []).filter((l) => Math.trunc(Number(l?.montant) || 0) > 0);
    if (!decaissement?.isReglementMultiple || !lignes.length) return null;

    // word-break/overflow-wrap : les contenus non sécables (police, immat) reviennent à la ligne
    // au lieu de faire déborder le tableau à droite de la page A4 (table-layout fixed + largeurs).
    const th = { padding: "4px", border: "1px solid black", wordBreak: "break-word", overflowWrap: "anywhere" };
    const td = { padding: "3px 4px", border: "1px solid black", wordBreak: "break-word", overflowWrap: "anywhere" };

    return (
        <div>
            <table border={1} style={{ width: "100%", tableLayout: "fixed", borderCollapse: "collapse", fontSize, fontFamily, color: "black" }}>
                <thead>
                    <tr style={{ background: "#f0f0f0" }}>
                        <th style={{ ...th, width: "17%" }}>N° Sinistre</th>
                        <th style={{ ...th, width: "18%" }}>Date de surv.</th>
                        <th style={{ ...th, width: "20%" }}>N° Police</th>
                        <th style={{ ...th, width: "14%" }}>N° Imma</th>
                        <th style={{ ...th, width: "17%" }}>Assuré</th>
                        {/* <th style={th}>Nature</th> */}
                        <th style={{ ...th, textAlign: "right", width: "14%" }}>Montant</th>
                    </tr>
                </thead>
                <tbody>
                    {lignes.map((ligne, idx) => {
                        const dossier = dossierDeLigne(ligne, sinistre);
                        return (
                            <tr key={idx}>
                                <td style={td}>{dossier.numeroSinistre}</td>
                                <td style={td}>{dossier.dateSinistre ? frenchDate(dossier.dateSinistre) : ""}</td>
                                <td style={td}>{dossier.numeroPolice}</td>
                                <td style={td}>{dossier.immatriculation}</td>
                                <td style={td}>{dossier.assure}</td>
                                {/* <td style={td}>{ligne.label}</td> */}
                                <td style={{ ...td, textAlign: "right" }}>{displayNumbers(Math.trunc(ligne.montant || 0))}</td>
                            </tr>
                        );
                    })}
                    {(() => {
                        const global = Math.trunc(parseFloat(decaissement?.montantGlobal) || 0);
                        const net = decaissement?.montantPaye != null
                            ? Math.trunc(parseFloat(decaissement?.montantPaye) || 0)
                            : global;
                        const retenue = global - net;
                        // Sans retenue : un seul Total. Avec retenue : Total (brut) → Retenue → Net à payer.
                        if (retenue <= 0) {
                            return (
                                <tr style={{ fontWeight: "bold" }}>
                                    <td colSpan={5} style={{ ...td, textAlign: "right" }}>Total</td>
                                    <td style={{ ...td, textAlign: "right" }}>{displayNumbers(global)}</td>
                                </tr>
                            );
                        }
                        return (
                            <>
                                <tr style={{ fontWeight: "bold" }}>
                                    <td colSpan={5} style={{ ...td, textAlign: "right" }}>Total (montant brut)</td>
                                    <td style={{ ...td, textAlign: "right" }}>{displayNumbers(global)}</td>
                                </tr>
                                <tr>
                                    <td colSpan={5} style={{ ...td, textAlign: "right" }}>Retenue</td>
                                    <td style={{ ...td, textAlign: "right" }}>{displayNumbers(retenue)}</td>
                                </tr>
                                <tr style={{ fontWeight: "bold" }}>
                                    <td colSpan={5} style={{ ...td, textAlign: "right" }}>Net à payer</td>
                                    <td style={{ ...td, textAlign: "right" }}>{displayNumbers(net)}</td>
                                </tr>
                            </>
                        );
                    })()}
                </tbody>
            </table>
            {/* {decaissement?.hasProvision && (
                <p style={{ marginTop: "8px", fontStyle: "italic", fontSize: "11px" }}>
                    NB : La provision est déductible de l'indemnité définitive.
                </p>
            )} */}
        </div>
    );
};

export default TableauDossiersGroupe;
